import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useScreenshotAttachment } from '@/components/feedback/useScreenshotAttachment'
import { useToast } from '@/components/layout/toastUtils'
import { useSubmitFeedback } from '@/hooks/useSubmitFeedback'

/** Form state, validation and submission for the feedback modal. */
export function useFeedbackForm(onClose: () => void) {
  const location = useLocation()
  const { showToast } = useToast()
  const { mutate, isPending } = useSubmitFeedback()

  const [category, setCategory] = useState('')
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [error, setError] = useState('')
  const attachment = useScreenshotAttachment(setError)

  const reset = () => {
    setCategory('')
    setTitle('')
    setDescription('')
    attachment.reset()
    setError('')
  }

  const handleClose = () => {
    reset()
    onClose()
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (!description.trim()) {
      setError('Please provide a description')
      return
    }

    mutate(
      {
        category: category || undefined,
        title: title || undefined,
        description: description.trim(),
        screenshot: attachment.screenshot || undefined,
        page_url: location.pathname,
      },
      {
        onSuccess: () => {
          showToast('Feedback submitted — thank you!', 'success')
          handleClose()
        },
        onError: () => {
          setError('Failed to submit feedback. Please try again.')
        },
      },
    )
  }

  const handleDescriptionChange = (value: string) => {
    setDescription(value)
    if (error) setError('')
  }

  return {
    category,
    setCategory,
    title,
    setTitle,
    description,
    handleDescriptionChange,
    error,
    attachment,
    isPending,
    handleClose,
    handleSubmit,
  }
}
